import React, { useEffect, useRef, useState } from 'react';

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

export default function AnimatedNumber({ value = 0, duration = 1000, format = (v) => v, className }) {
  const rafRef = useRef(null);
  const startRef = useRef(null);
  const fromRef = useRef(0);
  const [display, setDisplay] = useState(format(0));

  useEffect(() => {
    const start = performance.now();
    startRef.current = start;
    fromRef.current = parseFloat(display.toString().replace(/[^0-9.-]/g, '')) || 0;
    const to = Number(value || 0);
    const diff = to - fromRef.current;

    const step = (now) => {
      const t = clamp((now - start) / duration, 0, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const current = fromRef.current + diff * eased;
      setDisplay(format(Math.round(current)));
      if (t < 1) rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration]);

  return <span className={className}>{display}</span>;
}
